export enum UserManagerActions {
  OPEN_USER_DETAILS,
  CLOSE_MODAL,
  CLOSE_DIALOG,
  OPEN_MODAL,
  SELECT,
}
